export default __webpack_public_path__ + "static/media/Biscuit, Chips & Namkeen.dbf58ca4.png";